import { render } from "./AccordionsList.vue?vue&type=template&id=326cf6e4"
import script from "./AccordionsList.vue?vue&type=script&lang=js"
export * from "./AccordionsList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__